<template>
  <v-container>
    <v-card-text>
      <v-text-field
        :label="$t('user.fields.firstName')"
        name="firstname"
        prepend-icon="mdi-account-box-outline"
        type="text"
        v-model="user.firstName"
        v-on:change="updateEvent()"
        :rules="stringRules"
      ></v-text-field>
    </v-card-text>

    <v-card-text>
      <v-text-field
        :label="$t('user.fields.lastName')"
        name="lastname"
        prepend-icon="mdi-account-box-outline"
        type="text"
        v-model="user.lastName"
        v-on:change="updateEvent()"
        :rules="stringRules"
      ></v-text-field>
    </v-card-text>

    <v-card-text>
      <v-text-field
        :label="$t('user.fields.email')"
        name="email"
        prepend-icon="mdi-at"
        type="text"
        v-model="user.email"
        v-on:change="updateEvent()"
        :rules="stringRules"
      ></v-text-field>
    </v-card-text>

    <v-card-text>
      <phone-number-input v-model="user.phoneNumber" :validate="true" />
    </v-card-text>

    <v-card-text>
      <v-text-field
        v-if="!user.sso"
        :label="$t('user.fields.password')"
        name="password"
        prepend-icon="mdi-textbox-password"
        type="password"
        v-model="user.password"
        v-on:change="updateEvent()"
        :rules="advancedPasswordPolicy ? advancedPasswordRules : passwordRules"
      ></v-text-field>
      <v-switch
        name="sso-user"
        :label="$t('user.fields.sso')"
        v-model="user.sso"
        v-on:change="ssoSwitched()"
      />
    </v-card-text>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { GenerateRandomPassword } from "@/_helpers/commonHelper";

export default {
  name: "UserRegistrationInputs",
  props: ["eUser"],
  data() {
    return {
      valid: false,

      user: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        password: "",
        sso: false,
      },

      stringRules: [
        (v) => !!v || this.$t("validation.requiredSingle"),
        (v) => (v && v.length <= 255) || this.$t("validation.toLong"),
      ],

      phoneNumberRules: [
        (v) => !!v || this.$t("validation.requiredSingle"),
        (v) =>
          (v !== undefined && v[0] !== "0") ||
          this.$t("validation.contryCodeError"),
      ],

      passwordRules: [
        (v) => !!v || this.$t("validation.requiredSingle"),
        (v) => (v && v.length > 6) || this.$t("validation.passwordLength", [6]),
        (v) =>
          (v && this.upperAndLowerCase(v)) ||
          this.$t("validation.passwordUpperAndLower"),
      ],

      advancedPasswordRules: [
        (v) => !!v || this.$t("validation.requiredSingle"),
        (v) =>
          (v && v.length > 12) || this.$t("validation.passwordLength", [12]),
        (v) =>
          (v && this.upperAndLowerCase(v)) ||
          this.$t("validation.passwordUpperAndLower"),
        (v) =>
          (v && this.specialCharacter(v)) ||
          this.$t("validation.passwordSpecialCharacter"),
      ],
    };
  },

  created() {
    if (this.eUser !== undefined) {
      this.user.userId = this.eUser.userId;
      this.user.firstName = this.eUser.firstname;
      this.user.lastName = this.eUser.lastname;
      this.user.phoneNumber = this.eUser.phonenumber;
      this.user.email = this.eUser.email;
      this.user.password = this.eUser.password;
      this.user.sso = this.eUser?.sso || false;

      this.updateEvent();
    }
  },

  computed: {
    ...mapGetters("configuration", ["advancedPasswordPolicy"]),
  },

  methods: {
    upperAndLowerCase(val) {
      const upper = /[A-Z]/.test(val);
      const lower = /[a-z]/.test(val);

      return upper && lower;
    },

    specialCharacter(val) {
      const special = /[!@#$%^&*(),.?":{}|<>]/.test(val);

      return special;
    },

    updateEvent() {
      this.$emit("update-user", this.user);
    },

    ssoSwitched() {
      if (this.user.sso) {
        // Generate a random password for SSO users
        this.user.password = GenerateRandomPassword(16);
      }

      this.updateEvent();
    },
  },
};
</script>

<style></style>
